(function () {
  var description = document.querySelector('.product__description');
  var toggle = document.querySelector('.product__description-toggle');
  if (!description || !toggle) return;

  var EXPANDED_CLASS = 'product__description--expanded';
  var TOGGLE_EXPANDED_CLASS = 'product__description-toggle--expanded';
  var label = toggle.querySelector('.product__description-toggle-label');

  function isTruncated() {
    return description.scrollHeight > description.clientHeight + 1;
  }

  function updateVisibility() {
    if (description.classList.contains(EXPANDED_CLASS)) return;
    toggle.hidden = !isTruncated();
  }

  toggle.addEventListener('click', function () {
    var expanded = description.classList.toggle(EXPANDED_CLASS);
    toggle.classList.toggle(TOGGLE_EXPANDED_CLASS, expanded);
    toggle.setAttribute('aria-expanded', expanded);
    if (label) {
      label.textContent = expanded ? 'Réduire' : 'Lire la suite';
    }
  });

  updateVisibility();

  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateVisibility, 200);
  });
})();
